const ISSUE_COLOR_ORANGE = '#D48806';
const ISSUE_COLOR_SALMON = '#E49273';

export const issueColor = (blame?: string) =>
  blame === 'data' ? ISSUE_COLOR_SALMON : ISSUE_COLOR_ORANGE;

export default issueColor;
